import React, { useEffect, useState } from "react";
import "./add-unit-form.css";

interface AddUnitFormProps {
  propertyDetails: any; // Passed prop containing property details
  onUnitUpdate: (
    updatedDetails: any,
    e: React.FormEvent,
    editMode: boolean
  ) => void; // Callback for parent to handle updates
  unitDetails: any;
}

const AddUnitForm: React.FC<AddUnitFormProps> = ({
  propertyDetails,
  onUnitUpdate,
  unitDetails,
}) => {
  const [editMode, setEditMode] = useState<boolean>(false);
  const [unitDetailsForm, setUnitDetailsForm] = useState<any>({});
  const [selectedOption, setSelectedOption] = useState<string>("same");

  useEffect(() => {
    if (propertyDetails) {
      setUnitDetailsForm((prev: any) => ({
        ...prev,
        city: propertyDetails.city,
        state: propertyDetails.state,
        zipCode: propertyDetails.zipCode,
      }));
    }

    if (unitDetails) {
      setUnitDetailsForm(unitDetails);
      setEditMode(true);
    }
  }, [propertyDetails, unitDetails]);

  const radioChanged = (value: string) => {
    setSelectedOption(value);
  };

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value, type } = e.target;
    const isCheckbox = type === "checkbox";

    setUnitDetailsForm((prev: any) => ({
      ...prev,
      [name]: isCheckbox ? (e.target as HTMLInputElement).checked : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    unitDetailsForm.streetAddress = propertyDetails.streetAddress;
    unitDetailsForm.city = propertyDetails.city;
    unitDetailsForm.state = propertyDetails.state;
    unitDetailsForm.zipCode = propertyDetails.zipCode;
    unitDetailsForm.propertyId = propertyDetails.propertyId;

    unitDetailsForm.description = "";
    unitDetailsForm.modifiedBy = "";

    console.log("Form Data Submitted:", unitDetailsForm);
    // You can send `unitDetailsForm` to your API here
    onUnitUpdate(unitDetailsForm, e, editMode);
  };

  return (
    <form onSubmit={handleSubmit} className="tenant-rent-payment-form">
      <label>
        Is the unit address the same or different from{" "}
        {propertyDetails.streetAddress}?
      </label>
      <div className="button-radio-group">
        <label
          className={`button-radio ${
            selectedOption === "same" ? "active" : ""
          }`}
        >
          <input
            type="radio"
            name="options"
            value="option1"
            checked={selectedOption === "same"}
            onChange={() => radioChanged("same")}
            title="Your multifamily follows the Unit A, B, C, format"
          />
          The Same
        </label>
        <label
          className={`button-radio ${
            selectedOption === "different" ? "active" : ""
          }`}
        >
          <input
            type="radio"
            name="options"
            value="option2"
            checked={selectedOption === "different"}
            onChange={() => radioChanged("different")}
            title="i.e A duplex, quadplex or even 10 units may have each different addresses"
          />
          Different
        </label>
      </div>

      <label>
        Unit Name
        <input
          type="text"
          name="name"
          value={unitDetailsForm.name}
          onChange={handleChange}
          required
        />
      </label>

      {selectedOption === "different" && (
        <>
          <div className="form-group">
            <label htmlFor="streetAddress">Street Address:</label>
            <input
              type="text"
              id="streetAddress"
              name="streetAddress"
              value={unitDetailsForm.streetAddress}
              onChange={handleChange}
              required
              placeholder="Enter street address"
            />
          </div>
          <div className="form-group address-row">
            <div className="address-field">
              <label htmlFor="city">City:</label>
              <input
                type="text"
                id="city"
                name="city"
                disabled
                value={unitDetailsForm.city}
                onChange={handleChange}
                required
                placeholder="Enter city"
              />
            </div>

            <div className="address-field">
              <label htmlFor="state">State:</label>
              <input
                type="text"
                id="state"
                name="state"
                disabled
                value={unitDetailsForm.state}
                onChange={handleChange}
                required
                placeholder="Enter state"
              />
            </div>

            <div className="address-field">
              <label htmlFor="zipCode">Zip Code:</label>
              <input
                type="number"
                id="zipCode"
                disabled
                name="zipCode"
                value={unitDetailsForm.zipCode}
                onChange={handleChange}
                required
                placeholder="Enter zip code"
                maxLength={5}
                pattern="\d{5}"
              />
            </div>
          </div>
        </>
      )}

      <div className="form-group">
        <label>
          <input
            type="checkbox"
            name="isRented"
            checked={unitDetailsForm.isRented}
            onChange={handleChange}
          />
          Is this a rented property?
        </label>
      </div>
      <div className="form-group rent-row">
        <div className="form-group">
          <label htmlFor="desiredRent">Desired Rent:</label>
          <input
            type="number"
            id="desiredRent"
            name="desiredRent"
            value={unitDetailsForm.desiredRent}
            onChange={handleChange}
            required
            placeholder="Desired rent"
          />
        </div>

        {unitDetailsForm.isRented && (
          <>
            <div className="form-group">
              <label htmlFor="actualRent">Actual Rent:</label>
              <input
                type="number"
                id="actualRent"
                name="actualRent"
                value={unitDetailsForm.actualRent}
                onChange={handleChange}
                required
                placeholder="Actual Rent"
              />
            </div>

            <div className="form-group">
              <label htmlFor="rentKept">Rent Kept:</label>
              <input
                type="number"
                id="rentKept"
                name="rentKept"
                value={unitDetailsForm?.rentKept}
                onChange={handleChange}
                required
                placeholder="Kept Rent"
              />
            </div>
          </>
        )}
      </div>

      <button className="submit-button" type="submit">
        {!editMode ? "Add Unit" : "Update Unit"}
      </button>
    </form>
  );
};

export default AddUnitForm;
